var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCopyAndMove = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.046123 9.0868999c-2.4758223.04097-4.6451739 1.1027001-5.5202662 3.6849241-.8683354 2.562284 1.029111 7.187616 5.2115666 5.130684 6.9466816-3.416378 6.9432226.846298 8.6798926.846298 2.142202 0 4.339947-1.493011 4.339947-3.402825 0-1.70819.08467-3.343783-.871621-4.284384-1.73667-1.7081901-2.612274.867394-7.281667-1.040243-1.488137-.6079641-3.072358-.9590361-4.557852-.9344541z",
    style: {
      fill: "#a6cca6",
      fillRule: "evenodd",
      stroke: "#696b67",
      strokeWidth: 0.878466,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.6327639 13.832143c-2.475822.04097-4.645174 1.1027-5.520266 3.684924-.86833562 2.562284 1.029111 7.187616 5.211566 5.130684 6.9466821-3.416378 6.9432231.846298 8.6798931.846298 2.142202 0 4.339947-1.493011 4.339947-3.402825 0-1.70819.08467-3.343783-.871621-4.284384-1.73667-1.70819-2.612274.867394-7.281667-1.040243-1.4881371-.607964-3.0723581-.959036-4.5578521-.934454z",
    style: {
      fill: "#72b072",
      fillRule: "evenodd",
      stroke: "#41433f",
      strokeWidth: 0.878,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.5 6.000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#3c5a6e",
    height: 11,
    rx: 2.01149,
    width: 11,
    x: 40.5,
    y: 14.999999
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.500001 20.999999 8.999999-.009599s0 0 0-2c0-2.990401-1-2.990401-4.5-2.990401s-4.5 0-4.5 3c0 2 0 2 .000001 2z",
    fill: "#fcffff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.5 15.999999v3.000001h-4v3h4v2.999999l5-4z",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopyAndMove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy_and_move.5a6a6765.svg";
export { ForwardRef as ReactComponent };